import {Resource} from '~/app/core/common/resource';

export class Order extends Resource {
    customerId: string;
    store: string;
    deliveryDate: string;
    trackingId: string;
    orderNumber: string;
    releaseNumber: string;
    status: number;
    receiptTotal: number;
    salesTax: number;
    discount: number;
    surcharge: number;
    receivingStatus: string;
}
